import AbstractView from 'abstracts/AbstractView';
import Screen from "controllers/Screen";


export default class TransitionTitles extends AbstractView {


	constructor($wrapper) {
		super();
		this.$wrapper = $wrapper;
		this.$wrapper.addClass('transition-title-wrapper');
		this.split = null;
		this.init();
	}

	initEl() {
		this.split = new SplitText(this.$wrapper[0], {
			type: 'lines',
			linesClass: 'transition-title-line'
		});
		this.tw.show = ScrollTrigger.create({
			trigger: this.$wrapper[0],
			start: 'top 90%',
			onEnter: () => {
				this.$wrapper.addClass('show');
			}
		});
		this.tw.hide = ScrollTrigger.create({
			trigger: this.$wrapper[0],
			start: 'top bottom',
			onLeaveBack: () => {
				this.$wrapper.removeClass('show');
			}
		});
	}

	update() {
		this.split.split();
		$(this.split.lines).each((index, item) => {
			item.setAttribute('data-text', item.innerText);
		});
	}

	bindEvents() {
		Screen.on(Screen.E.RESIZE, this.resize, this);
		super.bindEvents();
	}

	unbindEvents() {
		Screen.off(Screen.E.RESIZE, this.resize, this);
		super.bindEvents();
	}

	resize(isMobileH) {
		if (!isMobileH) {
			this.update();
		}
	}

	destroy() {
		this.split = null;
		super.destroy();
	}
}
